export default {
    coach: null,
    last_date: 'today',
    available_dates: [],
    available_times: [],
};



// WEBPACK FOOTER //
// ./src/store/coach/state.js